import { oc } from '@orpc/contract';
import { createPolicyDraftInputSchema, policyVersionSchema } from '../schemas/policies.schemas.js';
/**
 * Opens a draft from a published or archived version. A tenant has at most one draft at a time, so a
 * second call returns the draft that already exists rather than creating a rival to it (plan §10).
 */
export const createPolicyDraftContract = oc
    .route({
    method: 'POST',
    path: '/policies/versions',
    tags: ['Policies'],
    summary: 'Open a draft of the policy',
})
    .input(createPolicyDraftInputSchema)
    .output(policyVersionSchema);
//# sourceMappingURL=create-policy-draft.contract.js.map